import Vue from 'vue'
import '@aws-amplify/ui/dist/style.css'
import Amplify, * as AmplifyModules from 'aws-amplify'
import {
    AmplifyPlugin
} from 'aws-amplify-vue'
import awsmobile from '@/aws-exports'

let landing;
if (process.env.NODE_ENV === "development") {
    landing = 'http://localhost:8080/'
} else landing = 'https://logintest.alerusfinancial.net:4433/'

const oauth = {
    // Domain name
    //domain: 'https://onealerustst.auth.us-east-2.amazoncognito.com',

    // Authorized scopes
    scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],

    // Callback URL
    redirectSignIn: landing,

    // Sign out URL
    redirectSignOut: 'http://localhost:8080',

    // 'code' for Authorization code grant, 
    // 'token' for Implicit grant
    responseType: 'code',

    // optional, for Cognito hosted ui specified options
    options: {
        // Indicates if the data collection is enabled to support Cognito advanced security features. By default, this flag is set to true.
        //AdvancedSecurityDataCollectionFlag: true
    }
}

Amplify.configure({
    graphql_endpoint: process.env.VUE_APP_APPSYNC_API_URL,
    graphql_headers: async () => ({
        'X-Api-Key': awsmobile.aws_appsync_apiKey
    }),
    userPoolId: process.env.VUE_APP_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_POOL_CLIENT_ID,
    identityPoolRegion: process.env.VUE_APP_AWS_REGION,
    authenticationFlowType: 'CUSTOM_AUTH'
})

Vue.use(AmplifyPlugin, AmplifyModules)